import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './Subjects.module.css';
import Navbar from '../../Navbar';
import Footer from '../UserPages/Footer';

function LanguageSubject() {
    const [staffMembers, setStaffMembers] = useState([]);

    useEffect(() => {
        // Fetch staff data for the "language" subject
        axios.get('https://school-web-server-eight.vercel.app/language')
            .then(response => {
                setStaffMembers(response.data);
            })
            .catch(error => {
                console.error('Failed to fetch staff members:', error);
            });
    }, []);

    return (
        <>
            <Navbar />
            <div>
                <div className={styles.subjectContainer}>
                    <div className={styles.backgroundHeader}>
                        <img src="\Images\schoolBuilding1.jpg" alt="" />
                        <div className={styles.header}> <h1>กลุ่มสาระการเรียนรู้ภาษาต่างประเทศ</h1></div>
                    </div>
                    <div className={styles.staff}>
                        {staffMembers.map((staff) => (
                            <div key={staff._id} className={styles.staffMember}>
                                <img src={`https://school-web-server-eight.vercel.app/staffImages/${staff.image}`} alt="" />
                                <div className={styles.personalDetails}>
                                    <strong>{staff.name}</strong>
                                    <br />
                                    {staff.position}
                                    <br />
                                    {staff.email}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default LanguageSubject;